import React from 'react';
import PropTypes from 'prop-types';
import { RichTextPropTypes } from '../../prop-types';
import RichTextAssembly from '../assemblies/rte';
import RichTextBase from './base';

/**
 * This default export for Rich Text should be called when
 * the RTE embeds other entries. These are from the RTE assembly
 * map. For a plain RTE that does not embed entries import from
 * `rich-text/base` instead. This helps prevent Circular References
 */
const RichText = (props) => (
  <RichTextBase assembly={RichTextAssembly} {...props} />
);

/**
 * 'default' prop type is used when no selection in Contentful is made
 */
RichText.propTypes = {
  richText: RichTextPropTypes,
  className: PropTypes.string,
  textRenderer: PropTypes.func,
  backgroundColor: PropTypes.oneOf(['default', 'white', 'grey']),
  padding: PropTypes.bool,
  linkData: PropTypes.object,
};

RichText.defaultProps = {
  backgroundColor: 'white',
};

export default RichText;
